import React from 'react';
import PingStatus from '../monitoramento/PingStatus';

export default function Zapi() {
  return (
    <PingStatus
      pingUrl="https://v1-csapi.compsoft.com.br:825/ping"
      restartKey="userapi"
      interval={20000}
    />
  );
}
